/**
 * Component: Post listing item scripts
 * ------------------------------------------------------------------------------
 * Scripts to run when the post listing item is in the page.
 *
 * @namespace postListingItem
 */
import {on, handleize} from '~/helpers/utils';
import Carousel from '~/components/carousel';

/**
 * DOM selectors.
 */
const selectors = {
  carousel: '[js-post-listing="carousel"]',
  slides: '[js-carousel="cell"]',
  cta: '[js-post-listing="cta"]',
  nav: '[js-professionals-navigation]',
};

const carousels = [];

/**
 * Create a new postListingItem object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    carousels: [...document.querySelectorAll(selectors.carousel)],
    cta: [...document.querySelectorAll(selectors.cta)],
    nav: document.querySelector(selectors.nav),
  };

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners();

    if (!nodeSelectors.carousels) {
      return;
    }

    setupCarousels();
    window.setTimeout(() => initiateCarousels(), 0);
  }

  /**
   * Setup event listeners
   */
  function setEventListeners() {
    nodeSelectors.cta.forEach((button) => {
      on('click', button, () => {
        const titleElement = nodeSelectors.nav.querySelector('.active');
        const title = handleize(titleElement.innerText.trim()).replace(/-/g, '_');
        const fileNameElement = button.closest('.post-listing-item__content').querySelector('.post-listing-item__title');
        const fileName = handleize(fileNameElement.innerText.trim()).replace(/-/g, '_');

        window.dataLayer.push({
          event: 'GAevent',
          eventID: '21',
          eventCategory: 'download',
          eventAction: title,
          eventLabel: fileName,
        });
      });
    });
  }

  /**
   * Setup all Carousels.
   */
  function setupCarousels() {
    nodeSelectors.carousels.forEach((element) => {
      const cells = [...element.querySelectorAll(selectors.slides)];

      if (cells.length < 2) {
        return;
      }

      carousels.push(Carousel(`#${element.id}`, {
        swiper: {
          allowTouchMove: true,
          loop: false,
          loopedSlides: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
          },
          slidesPerView: 1,
          spaceBetween: 0,
        },
      }));
    });
  }

  /**
   * Initiate Carousels once ready.
   */
  function initiateCarousels() {
    carousels.forEach((carousel) => carousel.init());
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
